import { render } from "./layout-two-column.vue?vue&type=template&id=c7013724"
import script from "./layout-two-column.vue?vue&type=script&lang=js"
export * from "./layout-two-column.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__